import { useFormikContext } from 'formik';
import PropTypes from 'prop-types';
import React, { useState } from 'react';
import { generatePath, Link } from 'react-router-dom';

import {
    assessmentManagerCloneRoute,
    assessmentManagerEditRoute,
    assessmentManagerQuestionsRoute,
} from 'App/common/routeLookup';
import DeleteModal from 'App/components/DeleteModal';
import ClickLink from 'App/components/styles/ClickLink';
import { useUserContext } from 'App/contexts/UserContext';
import useIsPermitted from 'App/utils/hooks/useIsPermitted';
import { PERMISSION_TYPES } from 'App/utils/isPermitted/isPermitted';
import AssessmentService from 'App/services/AssessmentService';
import { queryClient } from 'Shared/queryClient';

const ActionsCell = ({ row: { original } }) => {
    const { id, companyId } = original;
    const {
        values: { category },
    } = useFormikContext();
    const user = useUserContext();
    const isClinicalAdmin = useIsPermitted(PERMISSION_TYPES.CLINICAL_ADMIN);
    const canDeleteAssessment = isClinicalAdmin || user.active_company.ID === companyId;
    const [showDeleteModal, setShowDeleteModal] = useState(false);

    return (
        <>
            <Link to={generatePath(assessmentManagerQuestionsRoute, { categoryId: category.id, assessmentId: id })}>
                <ClickLink>Edit Questions</ClickLink>
            </Link>
            {' | '}
            <Link to={generatePath(assessmentManagerEditRoute, { categoryId: category.id, assessmentId: id })}>
                <ClickLink>Settings</ClickLink>
            </Link>
            {' | '}
            <ClickLink disabled={!canDeleteAssessment} onClick={() => setShowDeleteModal(true)}>
                Delete
            </ClickLink>
            {isClinicalAdmin && !companyId && (
                <>
                    {' | '}
                    <Link to={generatePath(assessmentManagerCloneRoute, { categoryId: category.id, assessmentId: id })}>
                        <ClickLink>Clone</ClickLink>
                    </Link>
                </>
            )}

            {showDeleteModal && (
                <DeleteModal
                    show
                    title="Delete Assessment"
                    message="Are you sure you want to delete this assessment?"
                    onHide={() => setShowDeleteModal(false)}
                    onDelete={async () => {
                        await AssessmentService.deleteAssessment(id, category.id);
                        setShowDeleteModal(false);
                        queryClient.invalidateQueries(['therapyAssessments', category.id]);
                    }}
                />
            )}
        </>
    );
};
ActionsCell.propTypes = {
    row: PropTypes.shape({
        original: PropTypes.shape({
            id: PropTypes.string,
            companyId: PropTypes.string,
        }),
    }).isRequired,
};

export default ActionsCell;
